import { Customer } from '../models/customer';

export class PoolerCustomerMap {
  map: { [key: string]: Customer };

  constructor(customers: Customer[]) {
    const map = {};
    customers.forEach((customer) => {
      customer.pool.activeUserIds.forEach((userId) => {
        // @ts-ignore
        if (!map[userId]) {
          // @ts-ignore
          map[userId] = customer;
        }
      });
      customer.createdUserIds?.forEach((userId) => {
        // @ts-ignore
        if (!map[userId]) {
          // @ts-ignore
          map[userId] = customer;
        }
      });
    });
    this.map = map;
  }

  getCustomerOfUser(userId: string): Customer | undefined {
    return this.map[userId];
  }
}
